import { render, staticRenderFns } from "./AlunosCadastrados.vue?vue&type=template&id=36f80d66"
import script from "./AlunosCadastrados.vue?vue&type=script&lang=js"
export * from "./AlunosCadastrados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports